import React from 'react';
import { Popup } from 'semantic-ui-react';
import moment from 'moment';

const TimeDisplay = ({ timestamp }) => {
  return (
    <Popup
      content={moment(timestamp).format('DD.MM.YYYY HH:mm')}
      trigger={
        <span>{moment(timestamp).fromNow()}</span>
      }
      basic
    />
  );
};

export default TimeDisplay;
